import React from 'react';
import RenderContent from 'app/components/layout/RenderContent';
import { Route } from 'react-router-dom';
import TeamsList from './components/TeamsList';
import TeamDetail from './components/TeamDetail';
// import TeamCreate from './components/TeamCreate';


interface ITeamsLayoutProps {
  appReady: boolean;
  match: any;
}
export default class TeamsLayout extends React.Component<ITeamsLayoutProps> {
  static defaultProps: ITeamsLayoutProps = {
    appReady: false,
    match: undefined,
  };

  render(): React.ReactNode {
    return (
      <RenderContent checkOrgLoaded className="teams-app" match={this.props.match}>
        <Route
          exact
          path={['/teams', '/teams\\::filterConfig']}
          render={(): React.ReactNode => (
            <TeamsList
              {...this.props}
              segment={this.props.match.params.segment}
            />
          )}
        />
        <Route
          exact
          path="/teams/detail/:teamId"
          render={(): React.ReactNode => (
            <TeamDetail
              appReady={this.props.appReady}
              match={this.props.match}
            />
          )}
        />
        {/* <TeamCreate
          {...this.props}
        /> */}
      </RenderContent>
    );
  }
}
